import { v4 } from 'uuid';

/** Returns a new UUID (wrapped for easy mocking in unit tests). */
export function newUuid(): string {
  return v4();
}

/** Returns an ISO timestamp for "now" (wrapped for easy mocking in unit tests). */
export function nowIsoString(): string {
  return new Date().toISOString();
}